const Field = ({entity, fld}) => {
    const {widget: Component, ...rest} = fld
    return (
        <Component
            entity={entity}
            {...rest}
        />
    )
}

export default Field